import React from "react";
import { useClaims } from "../../hooks/useClaims";

export function AuthCheckCustom({ fallback, children, requiredClaims }) {
  const { hasClaim, loading } = useClaims();

  if (loading) {
    return <>{fallback}</>;
  }

  if (!requiredClaims) {
    return <>{children}</>;
  }

  if (hasClaim(requiredClaims)) {
    return <>{children}</>;
  } else {
    return <>{fallback}</>;
  }
}
